import { useEffect } from 'react'

import useDeviceType from '@hooks/useDeviceType'
import amplitude from '@lib/analytics/amplitude'
import { useParams } from '@stores/params'

interface UseCookiesAnalyticsProps {
  opened: boolean
}

interface UseCookiesAnalyticsReturn {
  sendAcceptEvent: () => void
  sendRejectEvent: () => void
}

export const useCookiesAnalytics = ({ opened }: UseCookiesAnalyticsProps): UseCookiesAnalyticsReturn => {
  const deviceType = useDeviceType()
  const [{ retailerPartnerNumber, locale }] = useParams()

  useEffect(() => {
    if (opened) {
      amplitude.cookies.cookieBannerVisible(deviceType, retailerPartnerNumber.toString(), locale)
    }
  }, [opened, retailerPartnerNumber, locale, deviceType])

  return {
    sendAcceptEvent: amplitude.cookies.cookieBannerAccepted,
    sendRejectEvent: amplitude.cookies.cookieBannerRejected,
  }
}
